<template>
    <header>
        <div class="container">
            <img src="../../assets/logo/medfilm-logo.svg" height="50"/>
            <user-profile :authenticated="authenticated"></user-profile>
        </div>
    </header>
</template>

<script>
  import userProfile from './header/profile.vue'

  export default {
    props: ['authenticated'],
    components: {
      userProfile
    }
  }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss" scoped>
    header {
        position: relative;
        text-align: center;
        height: 100px;

        img {
            margin-top: 25px;
        }
    }
</style>


// WEBPACK FOOTER //
// header.vue?6d453e8b